import APIService, { withPrefix } from "@/services/APIService";
import JSONApiService from "@/services/JSONApiService";
import { REFERENCE_MODEL } from "@/models/reference-model";
import { disablePluralizeForCall } from "@/services/utils";
import {
  include,
  APPLICATIONS,
  USER,
  BOOKING,
  CONVERSATION,
  nested
} from "@/models/relationships";
import { OFFER_MODEL } from "@/models/offer-model";
import { EXPERIENCE_MODEL } from "@/models/experience-model";
import { REFEREE_MODEL } from "@/models/referee-model";
import { USER_MODEL } from "@/models/user-model";

const API = withPrefix(APIService.client(), "references");

const referenceIncludes = include(
  REFEREE_MODEL,
  USER,
  EXPERIENCE_MODEL,
  CONVERSATION,
  nested(APPLICATIONS, BOOKING)
);

const callReferenceAction = ({ id, action, commit }) => {
  const api = JSONApiService(commit);
  api.one(REFERENCE_MODEL, id);
  disablePluralizeForCall(api, () => api.all(action));
  return api.post({}, referenceIncludes);
};

const referenceApi = ({ commit } = {}) => ({
  addNewReference: async data =>
    JSONApiService(commit).create(REFERENCE_MODEL, data, referenceIncludes),
  deleteReference: async id => API.delete(`${id}`),
  getReferences: params =>
    JSONApiService(commit)
      .all(REFERENCE_MODEL)
      .get({
        ...params,
        ...referenceIncludes
      }),
  getReference: id =>
    JSONApiService(commit)
      .one(REFERENCE_MODEL, id)
      .get(
        include(
          REFEREE_MODEL,
          USER,
          EXPERIENCE_MODEL,
          CONVERSATION,
          OFFER_MODEL,
          nested(APPLICATIONS, BOOKING)
        )
      ),
  getUserReferences: async userId =>
    JSONApiService(commit)
      .one(USER_MODEL, userId)
      .all(REFERENCE_MODEL)
      .get(referenceIncludes),
  updateUserReference: async data =>
    JSONApiService(commit)
      .one(REFERENCE_MODEL, data.id)
      .patch(data, referenceIncludes),
  approveReference: async id =>
    callReferenceAction({ id, action: "approve", commit }),
  rejectReference: async id =>
    callReferenceAction({ id, action: "reject", commit }),
  submitReferenceForApproval: async id =>
    callReferenceAction({ id, action: "submit-for-approval", commit })
});

export default referenceApi;
